export default __webpack_public_path__ + "static/media/sc-mp-active-ico.19e23c5f.svg";